import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6900Model } from "../kymw6900.model";

interface GetSuggestionGoodsOutputResponse {
  FileUrl: string;
}
/**
 * 提案商品帳票出力項目を取得するサービス
 *
 * @export GetSuggestionGoodsOutputService
 * @class GetSuggestionGoodsOutputService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSuggestionGoodsOutputService extends PlessJsonResponderSub<GetSuggestionGoodsOutputResponse> {
  private model: KYMW6900Model;
  private proposalIds: string[];
  private sucessFunc: (fileUrl: string) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSuggestionGoodsOutputService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        ProposalIdList: {
          combination: this.proposalIds.map(id => ({
            parameter: {
              ProposalId: id
            }
          }))
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetSuggestionGoodsOutputService
   */
  execute(model: KYMW6900Model, proposalIds: string[], successFunc?: (fileUrl: string) => void): void {
    this.model = model;
    this.proposalIds = proposalIds;
    this.sucessFunc = successFunc;
    this.send('getSuggestionGoodsOutput', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSuggestionGoodsOutputService
   */
  success(data: GetSuggestionGoodsOutputResponse): void {
    if (this.sucessFunc) {
      this.sucessFunc(data.FileUrl);
    }
  }
}
